import { Container } from '@mui/material';

const UIContainer = Container;
export default UIContainer;
